module.exports = __webpack_public_path__ + "assets/ddb9ae47254c132f51329702941a7916.png";